// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sub-row[data-v-503546f2]{border-bottom:1px solid var(--sortable-table-top-divider);padding-left:1rem;padding-right:1rem}.col[data-v-503546f2]{display:flex;flex-direction:column}.col section[data-v-503546f2]{margin-bottom:1.5rem}.col .title[data-v-503546f2]{margin-bottom:.5rem}", ""]);
// Exports
module.exports = exports;
